import DateCell from '../../../elements/Table/Cells/DateCell'
import { attempt, get } from "lodash";
import React from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import Status from '../../../elements/Status'
import { Button, Select } from 'antd'
import InfoText from '../../../elements/InfoText'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'
import { GlobalContext } from '../../../Global'

const CheckboxTable = checkboxHOC(CustomTable)

//let LSMember = attempt(() => JSON.parse(localStorage.getItem('member'))) || ''


function List (props) {
  const { tenantOptions, member } = React.useContext(GlobalContext)
  const {
    list,
    fetch,
    fetching,
    isSelected,
    toggleSelection,
    tableRef,
    selection,
    removeSelection,
    removing,
    selectAll,
  } = props

  const checkboxProps = {
    selectType: 'checkbox',
    isSelected,
    toggleSelection,
    selectAll,
  }

  console.log(list)
  const columns = [
    {
      Header: 'Full Name',
      accessor: 't',
      Cell: ({ original, value }) => {
        return <a href={'/#/clients/registration/' + original._key}>{value}</a>
      },
    },
    {
      Header: 'Date Submitted',
      accessor: 'dataPrivacyNoticeAcknowledgement.date',
      width: 150,
      Cell: DateCell,
    },
    {
      Header: 'Company',
      accessor: 'realm',
      width: 150,
    },

    {
      Header: 'Status',
      accessor: 'status',
      width: 120,
      Cell: ({ value }) => <Status value={value}/>,
      filterMethod: (filter, row) => {
        const activeArray = ['new']
        const nonActiveArray = ['approved']
        if (filter.value === 'all') {
          return true
        }
        return filter.value === true
          ? activeArray.includes(row[filter.id])
          : nonActiveArray.includes(row[filter.id])
      },
      Filter: ({ onChange, filter }) => (
        <Select
          onChange={value => onChange(value)}
          style={{ width: '100%' }}
          value={filter ? filter.value : 'all'}>
          <Select.Option value="all">All</Select.Option>
          <Select.Option value={true}>New</Select.Option>
          <Select.Option value={false}>Approved</Select.Option>
        </Select>
      ),
    },
  ]

  return (
    <div>
      {/*<InfoText*/}
      {/*  text={*/}
      {/*    <span>*/}
      {/*      List below is based on Client registrations at the following location:*/}

      {/*      {['tenantGroup/10334060992970','tenantGroup/10334064017733'].includes(get(member, 'tenantGroup._id')) ?*/}
      {/*        (*/}
      {/*          <a href={`https://vendor.${get(member, 'tenantGroup.baseURL')}`} target={'_blank'}> {get(member, 'tenantGroup.name')} VENDOR REGISTRATION</a>*/}
      {/*        ) :*/}
      {/*        (*/}
      {/*        <>*/}
      {/*      <a href={'https://client.mmeagroup.com/'} target={'_blank'}>*/}
      {/*        <span style={{ marginLeft: 4, marginRight: 4 }}>MMEA</span>*/}
      {/*      </a>*/}
      {/*      ,*/}
      {/*      <a href={'https://client.mondiale.com/'} target={'_blank'}>*/}
      {/*        <span style={{ marginLeft: 4, marginRight: 4 }}>MONDIALE</span>*/}
      {/*      </a>*/}
      {/*      And*/}
      {/*      <a href={'https://client.souter-trading.com'} target={'_blank'}>*/}
      {/*        <span style={{ marginLeft: 4, marginRight: 4 }}>SOUTER</span>*/}
      {/*      </a>*/}
      {/*      </>*/}
      {/*      )}*/}
      {/*    </span>*/}
      {/*  }*/}
      {/*/>*/}

      <CheckboxTable
        {...checkboxProps}
        withRef={tableRef}
        data={list}
        defaultPageSize={10}
        isFilterable={true}
        fetching={fetching}
        fetch={fetch}
        columns={columns}
        CreateButton={() => (
          <Button
            size={'small'}
            type={'danger'}
            loading={removing}
            onClick={removeSelection}
            disabled={selection.length === 0}
            style={{ float: 'left' }}>
            Remove Selection
          </Button>
        )}
        defaultSorted={[
          {
            id: 'dataPrivacyNoticeAcknowledgement.date',
            desc: true,
          },
        ]}
        defaultFiltered={[
          {
            id: 'status',
            value: true,
          },
        ]}
      />
    </div>
  )
}

export default List
